<template>
    <div class="window bg">
        <div class="container">
            <menu-option v-bind:back="true" v-bind:is-white="true" v-bind:is-help="false"
                         class="container-horizontal_flex-start"  v-bind:back-route="'/instruction'"></menu-option>
            <div class="img-container">
                <transition :css="false" @enter="enterAnimation" appear>

                <img :src="getCharacter.normalImage" class="img-container_img">
                </transition>

                <div class="position-absolute_bottom">
                    <transition :css="false" @enter="enterAnimation" appear>

                        <div class="button-container">
                            <button class="btn-primary" @click="goToPractice">
                                <ruby>練習
                                    <rt>れんしゅう</rt>
                                </ruby>
                            </button>
                        </div>
                    </transition>

                    <transition :css="false" @enter="enterAnimation" appear>

                        <div class="">
                            <button class="btn-primary" @click="gotToFree">
                                <ruby>実践
                                    <rt>じっせん</rt>
                                </ruby>
                            </button>
                        </div>
                    </transition>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import MenuOption from "../components/MenuOption";
    import anime from 'animejs';
    import {mapGetters} from 'vuex';


    export default {
        name: "Menu",
        methods: {
            goToPractice() {
                this.$router.push("/practice");
            },
            gotToFree() {
                this.$router.push("/free");
            },
            enterAnimation(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            }
        },
        components: {
            MenuOption
        },
        computed: {
            ...mapGetters(['getCharacter'])
        }
    };
</script>

<style scoped>
</style>
